export enum ScenePurposes {
  StudioReview = 'design.studio.review',
}
